import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { captureException } from '@sentry/nextjs'

import { ADD_TO_CART_BUTTON_TEST_ID } from '../../utils/constants'

const BUTTON_BOTTOM_OFFSET = 60
const BUTTON_BOTTOM_THRESHOLD = 180

const useIsUnderAddProductButtons = (): boolean => {
  const [isUnderAddProductButtons, setIsUnderAddProductButtons] = useState(false)
  const { pathname } = useRouter()

  useEffect(() => {
    // Only apply this logic on single product pages
    if (!pathname.includes('/product/')) {
      setIsUnderAddProductButtons(false)
      return undefined
    }

    const handleScroll = () => {
      try {
        // Find the AddProductButtonsSPP component by its data-testid
        // Look for order button
        const addToCartButton = document.querySelector(`[data-testid="${ADD_TO_CART_BUTTON_TEST_ID}"]`)

        if (addToCartButton) {
          const buttonRect = addToCartButton.getBoundingClientRect()

          setIsUnderAddProductButtons((prevState) => {
            const isBelowButton = buttonRect.bottom < -BUTTON_BOTTOM_OFFSET
              || (prevState && buttonRect.bottom < BUTTON_BOTTOM_THRESHOLD)

            return isBelowButton
          })
        } else {
          setIsUnderAddProductButtons(false)
        }
      } catch (error) {
        // Silently handle any errors to prevent breaking the app
        console.warn('Error in useIsUnderAddProductButtons:', error)
        captureException(error)
      }
    }

    // Initial check
    handleScroll()

    // Add scroll listener
    window.addEventListener('scroll', handleScroll, { passive: true })

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [pathname])

  return isUnderAddProductButtons
}

export default useIsUnderAddProductButtons
